import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import ScribeLink from 'apps/scribe/ScribeLink';
import PageEvents from 'apps/header/models/PageEvents';
import PageEventFields from 'apps/header/models/PageEventFields';
import { wa } from 'apps/analytics';

export default class SeasonalBanner extends PureComponent {
  static propTypes = {
    seasonalEvent: PropTypes.shape({
      link: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired,
      buttonText: PropTypes.string,
      description: PropTypes.string,
    }).isRequired,
  };

  onClick = () => {
    const { seasonalEvent } = this.props;
    wa.triggerPageEventWithDescription(PageEvents.SEASONAL_BANNER_CLICKED, {
      [PageEventFields.BANNER_LINK]: seasonalEvent.link,
    });
  };

  render() {
    const { seasonalEvent } = this.props;

    return (
      <div className="hd-events__item">
        <ScribeLink className="hd-events__imgLink" to={seasonalEvent.link} onClick={this.onClick}>
          <img className="hd-events__img" src={seasonalEvent.imageUrl} alt={seasonalEvent.buttonText} />
        </ScribeLink>

        {seasonalEvent.description && (
          <p className="hd-events__description">{seasonalEvent.description}</p>
        )}

        {seasonalEvent.buttonText && (
          <ScribeLink to={seasonalEvent.link} className="button hd-events__btn" onClick={this.onClick}>
            {seasonalEvent.buttonText}
          </ScribeLink>
        )}
      </div>
    );
  }
}
